(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Scorocode", [], factory);
	else if(typeof exports === 'object')
		exports["Scorocode"] = factory();
	else
		root["Scorocode"] = factory();
})(window, function() {
return 